import { render, staticRenderFns } from "./VeBlockMarginsSettings.vue?vue&type=template&id=cba038ca"
import script from "./VeBlockMarginsSettings.vue?vue&type=script&lang=js"
export * from "./VeBlockMarginsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports